export const UPDATE_LOADING_PERCENT = 'UPDATE_LOADING_PERCENT';

export function updateLoadingPercent(percent) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_LOADING_PERCENT,
      percent,
    });
  };
}
